<section class="event-shift-card-wrapper">
  <div class="card">
    <div class="flex-row-between-center mb-8">
      <h5 class="shift-card-heading">{{ shift.title }}</h5>
      @if (!hideActions) {
        @if (!isMobileView()) {
          <div class="cursor-pointer">
            @if (!hideDeleteIcon) {
              <app-icon (click)="delete.emit(shift)" [tippy]="'Delete' | translate" class="ml-6" color="var(--slate-gray)" iconName="trash-bin" size="16px"></app-icon>
            }
            <app-icon (click)="edit.emit(shift)" [tippy]="'Edit' | translate" class="ml-6" color="var(--slate-gray)" iconName="pencil" size="16px"></app-icon>
          </div>
        }
        @if (isMobileView()) {
          <div>
            <app-icon
              [tippy]="options"
              class="cursor-pointer"
              className="popper-menu"
              color="var(--text-color-medium)"
              iconName="v-ellipsis"
              placement="bottom-start"
              size="16px"
              variation="popper"
              zIndex="300"
            ></app-icon>
            <!-- Pop -->
          </div>
        }
      }
    </div>
    <!--    <hr />-->
    <div class="image-wrapper-layout background-loading-small">
      <img [src]="shift.imageUrl" alt="" appDefaultImage loading="lazy" />
    </div>
    <div class="flex-row-between-center mt-10">
      <div>
        <p class="shift-card-heading" translate>Date</p>
        <p class="shift-card-text">{{ shift.date | date: 'dd.MM.yyyy' : 'UTC' }}</p>
      </div>
      <div>
        <p class="shift-card-heading" translate>Time</p>
        <p class="shift-card-text">{{ shift.startTime }} - {{ shift.endTime }}</p>
      </div>
    </div>
    <div class="mt-8">
      <div class="shift-description-wrapper">
        <p [innerHTML]="shift.description" class="shift-card-text">
          {{ shift.description }}
        </p>
      </div>
    </div>
    <div class="mt-8">
      <div class="flex-row-between-center">
        <p class="shift-card-heading" translate>Assign to</p>
        @if (isUploadADocument) {
          <app-icon (click)="downloadDocument()" cssClass="cursor-pointer" iconName="download" marginTop="-3px"></app-icon>
        }
      </div>
      <div class="users-list-wrapper">
        @for (user of shift.shiftUsers; track user) {
          <p class="shift-card-text">{{ user.fullName }}</p>
        }
      </div>
    </div>
  </div>
</section>

<ng-template #options let-hide>
  <!-- This menu-content is generic class can be override with custom style as well, adjust width value directly as per need -->
  <div class="popper-menu-content" style="width: max-content">
    <ul>
      <li (click)="edit.emit(shift); hide()">
        <app-icon iconName="pencil" size="20px"></app-icon>
        <label translate> Edit </label>
      </li>
      @if (!hideDeleteIcon) {
        <li (click)="delete.emit(shift); hide()">
          <app-icon iconName="trash-bin" size="20px"></app-icon>
          <label translate> Delete </label>
        </li>
      }
    </ul>
  </div>
</ng-template>
